var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('v-progress-circular',{attrs:{"size":30,"color":"rgba(255, 255, 255)","indeterminate":""}}),_vm._v("\n    "+_vm._s(_vm.text)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }